import { OrderItemSerializable } from './order-item-serializable';

export class SfdcDepositOrderItemSerializable extends OrderItemSerializable {
  sfdcDepositAmount: number = null;
  adjustment: number = null;
  replacesTotal: boolean = null;
}
